import api from '@/api/partnerBanks';

const state = {
  all: [],
  partnerBank: {},
};

const getters = {
  partnerBank: (state) => state.partnerBank,
  activePartnerBanks: (state) => state.all.filter((b) => b.status === 'ACTIVE'),
};

const actions = {
  getAllPartnerBanks: async (context) => {
    let d = (await api.getAllPartnerBanks()).data;
    context.commit('setAllPartnerBanks', d);
  },
  searchPartnerBanks: async (context, params) => {
    let d = (await api.searchPartnerBanks(params)).data;
    context.commit('setAllPartnerBanks', d);
    return d;
  },
  getPartnerBank: async (context, id) => {
    let d = (await api.getPartnerBank(id)).data;
    context.commit('setPartnerBank', d);
    return d;
  },
  postPartnerBank: async (context, bank) => {
    const result = (await api.postPartnerBank(bank)).data;
    context.commit('setPartnerBank', result);
    return result;
  },
  putPartnerBank: async (context, bank) => {
    const result = (await api.putPartnerBank(bank)).data;
    context.commit('setPartnerBank', result);
    return result;
  },
  deletePartnerBank: async (context, bank) => {
    await api.deletePartnerBank(bank);
    context.commit('deletePartnerBank', bank);
  },
  cashAmountUpdate: async (_context, { bankName, cashAmount }) => {
    const result = (await api.cashAmountUpdate(bankName, cashAmount)).data;
    return result;
  },
  buyGold: async (context, { bankName, payment, gram, companyId, receiptUrl }) => {
    const result = (await api.buyGold(bankName, payment, gram, companyId, receiptUrl)).data;
    context.commit('upsertPartnerBank', result);
    return result;
  },
  transferCashToAnotherBank: async (context, { fromBankName, toBankName, amount, transferFee, companyId, receiptUrl }) => {
    const result = (await api.transferCashToAnotherBank(fromBankName, toBankName, amount, transferFee, companyId, receiptUrl)).data;
    context.commit('upsertPartnerBank', result);
    return result;
  },
  transferGoldToAnotherBank: async (context, { fromBankName, toBankName, gram, transferFee, companyId, receiptUrl }) => {
    const result = (await api.transferGoldToAnotherBank(fromBankName, toBankName, gram, transferFee, companyId, receiptUrl)).data;
    context.commit('upsertPartnerBank', result);
    return result;
  },
  processExternalPayments: async (context, { bankName, payment, paymentType, companyId, paymentTypeOtherText }) => {
    const result = (await api.processExternalPayments(bankName, payment, paymentType, companyId, paymentTypeOtherText)).data;
    context.commit('upsertPartnerBank', result);
    return result;
  },
  addIncomingPayment: async (context, { bankName, amount, companyId }) => {
    const result = (await api.addIncomingPayment(bankName, amount, companyId)).data;
    context.commit('upsertPartnerBank', result);
    return result;
  },
};

const mutations = {
  setAllPartnerBanks(state, banks) {
    state.all = banks;
  },
  setPartnerBank(state, bank) {
    state.partnerBank = Object.assign({}, bank);
  },
  deletePartnerBank(state, bank) {
    state.all = state.all.filter((b) => b.id !== bank.id);
  },
  upsertPartnerBank(state, bank) {
    const idx = state.all.findIndex((b) => b.id === bank.id);
    if (idx >= 0) {
      state.all.splice(idx, 1, bank);
    } else {
      state.all.unshift(bank);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
